import { render, staticRenderFns } from "./ProjectMenu.vue?vue&type=template&id=56983329&scoped=true&"
import script from "./ProjectMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMenu.vue?vue&type=style&index=0&id=56983329&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56983329",
  null
  
)

export default component.exports